import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_InfoSection = _resolveComponent("InfoSection")!
  const _component_FinanceInfoSection = _resolveComponent("FinanceInfoSection")!
  const _component_DealsSection = _resolveComponent("DealsSection")!
  const _component_ConnectionsSection = _resolveComponent("ConnectionsSection")!
  const _component_TargetSection = _resolveComponent("TargetSection")!
  const _component_OpportunitiesSection = _resolveComponent("OpportunitiesSection")!
  const _component_OfficialSourcesSection = _resolveComponent("OfficialSourcesSection")!
  const _component_ClientsStatsSection = _resolveComponent("ClientsStatsSection")!
  const _component_CompaniesStatsSection = _resolveComponent("CompaniesStatsSection")!
  const _component_BenefitsSection = _resolveComponent("BenefitsSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeroSection),
    _createVNode(_component_InfoSection),
    _createVNode(_component_FinanceInfoSection),
    _createVNode(_component_DealsSection),
    _createVNode(_component_ConnectionsSection),
    _createVNode(_component_TargetSection),
    _createVNode(_component_OpportunitiesSection),
    _createVNode(_component_OfficialSourcesSection),
    _createVNode(_component_ClientsStatsSection),
    _createVNode(_component_CompaniesStatsSection),
    _createVNode(_component_BenefitsSection)
  ], 64))
}